export default "__VITE_ASSET__BdmPPMIm__";